import { DialogComponent, DialogOpenEvent } from '@theme/dialog';

/**
 * PDP stock-notification drawer — mobile bottom sheet, desktop right-slide.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog
 *
 * @extends {DialogComponent}
 */
class BtNotifyDrawer extends DialogComponent {
  requiredRefs = ['dialog'];

  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    super.connectedCallback();
    this.#abortController = new AbortController();
    this.addEventListener(DialogOpenEvent.eventName, this.#onDialogOpen, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
    this.#abortController = null;
  }

  #onDialogOpen = () => {
    const input = this.querySelector('input[type="email"]');
    if (input instanceof HTMLInputElement) input.focus();
  };
}

if (!customElements.get('bt-notify-drawer')) {
  customElements.define('bt-notify-drawer', BtNotifyDrawer);
}
